import router from '@/router'
import store from '@/store'

export const UNAUTHORIZED_RESPONSE_INTERCEPTOR = [
  response => response,
  error => {
    if (error.response.status === 401) {
      store.dispatch('account/logout')
      router.push('/acessar')
      return Promise.resolve(error.response)
    }
    if (error.response.status === 422) {
      return Promise.resolve(error.response)
    } else {
      return Promise.reject(error)
    }
  }
]

export const REQUEST_TOKEN_INTERCEPTOR = [
  config => {
    config.headers['Authorization'] = 'bearer ' + store.getters['account/token']
    return config
  },
  Promise.reject
]



// WEBPACK FOOTER //
// ./src/interceptors/index.js